export function getBrowserLanguagePreferences(): readonly string[] {
  if (typeof navigator === 'undefined') {
    return [];
  }

  if (navigator.languages.length > 0) {
    return navigator.languages;
  }

  if (navigator.language) {
    return [navigator.language];
  }

  return [];
}
